import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scroll restoration on route changes - instant scroll to prevent mobile layout issues
 */
export const useScrollOptimization = () => {
  const location = useLocation();

  useEffect(() => {
    // Instant scroll to top on route change to prevent mobile layout issues
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [location.pathname]);
};
